import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";
import i18n from "../i18n";
// components
import Slider from "../components/home/Slider.vue";
import Video from "../components/home/Video.vue";
import AboutDrug from "../components/home/AboutDrug.vue";
import Device from "../components/home/Device.vue";
import Efficiency from "../components/home/Efficiency.vue";
import SecurityProfile from "../components/home/SecurityProfile.vue";
import Application from "../components/home/Application.vue";
import Rynit from "../components/home/Rynit.vue";
// views
import HomeView from "../views/Home.vue";
import AboutDrugView from "../views/AboutDrug.vue";
import DeviceView from "../views/Device.vue";
import EfficiencyView from "../views/Efficiency.vue";
import SecurityProfileView from "../views/SecurityProfile.vue";
import AcuteRhinitisView from "../views/AcuteRhinitis.vue";
import AllergicRhinitisView from "../views/AllergicRhinitis.vue";
import VasomotorRhinitisView from "../views/VasomotorRhinitis.vue";

Vue.use(VueRouter);
Vue.use(VueMeta);

const routes = [
  {
    path: "*",
    redirect: `/${i18n.locale}/`
  },
  {
    path: "/",
    redirect: `/${i18n.locale}/`
  },
  {
    path: "/:lang/",
    component: {
      render(c) {
        return c("router-view");
      }
    },
    children: [
      {
        path: "/",
        component: HomeView,
        children: [
          {
            path: "/",
            component: Slider,
            meta: {
              hash: "slider"
            }
          },
          {
            path: "video",
            component: Video,
            meta: {
              hash: "video"
            }
          },
          {
            path: "pro-preparat",
            component: AboutDrug,
            meta: {
              hash: "pro-preparat"
            }
          },
          {
            path: "prystriy",
            component: Device,
            meta: {
              hash: "prystriy"
            }
          },
          {
            path: "efektyvnist",
            component: Efficiency,
            meta: {
              hash: "efektyvnist"
            }
          },
          {
            path: "profil-bezpeky",
            component: SecurityProfile,
            meta: {
              hash: "profil-bezpeky"
            }
          },
          {
            path: "zastosuvannya",
            component: Application,
            meta: {
              hash: "zastosuvannya"
            }
          },
          {
            path: "rynit",
            component: Rynit,
            meta: {
              hash: "rynit"
            }
          }
        ]
      },
      {
        path: "/",
        component: HomeView,
        children: [
          {
            path: "/",
            component: Slider,
            meta: {
              hash: "slider"
            }
          },
          {
            path: "video",
            component: Video,
            meta: {
              hash: "video"
            }
          },
          {
            path: "o-preparate",
            component: AboutDrug,
            meta: {
              hash: "o-preparate"
            }
          },
          {
            path: "ustroystvo",
            component: Device,
            meta: {
              hash: "ustroystvo"
            }
          },
          {
            path: "effektivnost",
            component: Efficiency,
            meta: {
              hash: "effektivnost"
            }
          },
          {
            path: "profil-bezopasnosti",
            component: SecurityProfile,
            meta: {
              hash: "profil-bezopasnosti"
            }
          },
          {
            path: "primeneniye",
            component: Application,
            meta: {
              hash: "primeneniye"
            }
          },
          {
            path: "rinit",
            component: Rynit,
            meta: {
              hash: "rinit"
            }
          }
        ]
      },
      {
        path: "pro-preparat/diyucha-rechovyna-oxymetazoline",
        component: AboutDrugView
      },
      {
        path: "o-preparate/deystvuyushcheye-veshchestvo-oxymetazoline",
        component: AboutDrugView
      },
      {
        path: "prystriy/detalnishe-pro-dozuyuchyy-prystriy",
        component: DeviceView
      },
      {
        path: "ustroystvo/detalneye-o-doziruyushchem-ustroystve",
        component: DeviceView
      },
      {
        path: "efektyvnist/shvydkist-ta-tryvalist-diyi",
        component: EfficiencyView
      },
      {
        path: "effektivnost/bystrota-idlitelnost-deystviya",
        component: EfficiencyView
      },
      {
        path: "profil-bezpeky/bilshe-pro-bezpeku",
        component: SecurityProfileView
      },
      {
        path: "profil-bezopasnosti/bolshe-o-bezopasnosti",
        component: SecurityProfileView
      },
      {
        path: "rynit/hostryy-rynit",
        component: AcuteRhinitisView
      },
      {
        path: "rinit/ostryy-rinit",
        component: AcuteRhinitisView
      },
      {
        path: "rynit/alerhichnyy-rynit",
        component: AllergicRhinitisView
      },
      {
        path: "rinit/allergicheskiy-rinit",
        component: AllergicRhinitisView
      },
      {
        path: "rynit/vazomotornyy-rynit",
        component: VasomotorRhinitisView
      },
      {
        path: "rinit/vazomotornyy-rinit",
        component: VasomotorRhinitisView
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: "/",
  routes
});

export default router;
